import React from 'react';

const VideoSelect = ({ uniqIdVideos, register, defaultValue }) => {
    return (
        <div>
            <label htmlFor="choseID"> select video for quiz</label>
            {
                uniqIdVideos?.length ? <select  {...register("video_id", { required: true })} id='choseID' defaultValue={defaultValue} className='block w-full login-input rounded-md '>
                    <option value={undefined} hidden >Select video</option>
                    {uniqIdVideos.map(single => <option className='my-2' key={single.id} value={single.id}>{single.title}</option>)}
                </select> :
                    <div>
                        No uniq videos found to add Assignment
                    </div>
            }
        </div>
    );
};

export default VideoSelect;